/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface PublicStorageControllerLogo$Params {
  /**
   * Key S3 del logo (es: `tenantId/logo.png`)
   */
  key: string;
}

export function publicStorageControllerLogo(
  http: HttpClient,
  rootUrl: string,
  params: PublicStorageControllerLogo$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, publicStorageControllerLogo.PATH, 'get');
  if (params) {
    rb.query('key', params.key, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

publicStorageControllerLogo.PATH = '/public/storage/logo';
